import that from '../../utilities/translationHelper'
import temperatureTypes from '../../enums/temperatureTypes'

const getTempRangeDisplay = (post) => {
	const { lowTemperature: low, highTemperature: high } = post
	if (typeof low === 'undefined' && typeof high === 'undefined') {
		return ''
	}
	return low === high ? that.context.translate('{low}{tempDisplay}', {
		low,
		tempDisplay: temperatureTypes[post.temperatureType || 'CELSIUS'].shortName
	}) : that.context.translate('{low} to {high}{tempDisplay}', {
		low: typeof low !== 'undefined' ? low : '?',
		high: typeof high !== 'undefined' ? high : '?',
		tempDisplay: temperatureTypes[post.temperatureType || 'CELSIUS'].shortName
	})
}

export default getTempRangeDisplay



// WEBPACK FOOTER //
// ./src/components/Item/getTempRangeDisplay.js